<comment>
webGL描画エリア
訴求ポイントマーカー、ズームボタンコンポーネントを含む
</comment>

<template>
  <div class="viewerArea" ref="viewerArea">
    <div class="cavas-wrap">
      <canvas ref="canvas"></canvas>
      <template v-if="!isTabletMode">
        <featureMarker v-for="point in featureMarkerPosition" @featureMarkerClick="displayFeature" :key="point.id" :x="point.x" :y="point.y" :id="point.id"></featureMarker>
      </template>
    </div>
    <zoomBtns @zoomInClicked="zoomChange(1)" @zoomOutClicked="zoomChange(-1)" @zoomResetClicked="zoomChange(0)" :zoomMaxFlg="zoomMaxFlg" :zoomMinFlg="zoomMinFlg" :zoomResetFlg="zoomResetFlg"></zoomBtns>
    <loadingIcon v-if="imgLoading"></loadingIcon>
    <guide v-if="firstImgLoaded"></guide>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import featureMarker from './featureMarker'
import zoomBtns from './zoomBtns'
import loadingIcon from './loadingIcon'
import guide from './guide'


export default {
  name: "viewerArea",
  components:{featureMarker,zoomBtns,loadingIcon,guide},
  data(){
    const width = 1360;
    const height = 709;
    const scene = new THREE.Scene();
    const renderer = null;
    const camera = new THREE.PerspectiveCamera(60, width / height, 1, 10000);
    const focus = new THREE.Vector3(-10, 0, 0);
    const controls = null;
    const sphereMesh = null

    return {
      width, height, scene, renderer, camera, focus, controls,sphereMesh,
      featureMarkersMeshArr: [],
      featureMarkerPosition: {},
      zoom: null,//5段階、-2,-1,0,1,2を指定
      initialZoom: -1,//ズーム初期値
      zoomBusy: false,//ズームアニメーション中フラグ
      imgLoading: false,
      firstImgLoaded: false,//ガイドの表示制御用、一回でも画像が表示されたら以降true
      fitsizeSaved_w:null,
      fitsizeSaved_h:null,
    };
  },
  computed: {
    ...mapState([
      'isTabletMode',
    ]),
    ...mapGetters([
      'mainImagePath',
      'enabledFeatures',
    ]),
    zoomResetFlg: function(){
      return this.zoom === this.initialZoom;
    },
    zoomMaxFlg:function(){
      return this.zoom === 2;
    },
    zoomMinFlg:function(){
      return this.zoom === -2;
    },
  },
  watch: {
    mainImagePath: function(path){
      this.setMaterial(path);
    },
    enabledFeatures: function(data){
      this.setFeatureMarker(data);
    },
    zoom: function(after,before){
      const thisVue = this;
      this.zoomBusy = true;
      const zoomParamMap = {
        '2':3,
        '1':1.5,
        '0':1,
      };
      const translateZstep = 200;
      //beforeがnull時は初期拡縮反映 0以外の値でアニメーションなしで反映
      if(before===null){
        if(after<0){//負
          thisVue.camera.translateZ(translateZstep*(-after));
          thisVue.camera.updateProjectionMatrix();
        }else if(after>0){//正
          thisVue.camera.zoom = 3;
          thisVue.camera.updateProjectionMatrix();
        }
        this.zoomBusy = false;
        return;
      }
      //通常時の拡縮反映
      //正負の範囲別に異なる仕様のアニメーション関数を呼ぶ
      function doZoom(a,b){
        if(a >= 0 && b >= 0){//正の範囲（0〜2）の拡縮
          return thisVue.zoomInAnimationTypeP(zoomParamMap[a]);
        }else if(a <= 0 && b <= 0){//負の範囲（0〜-2）の拡縮
          return thisVue.zoomInAnimationTypeN(translateZstep*(b-a));
        }
      }
      if(after >= 0 && before >= 0){//正の範囲（0〜2）の拡縮
        doZoom(after, before).then(()=>{this.zoomBusy = false;});
      }else if(after <= 0 && before <= 0){//負の範囲（0〜-2）の拡縮
        doZoom(after, before).then(()=>{this.zoomBusy = false;});
      }else if((after < 0 && before > 0) || after > 0 && before < 0){//0をまたいだ拡大縮小
        //正負で拡大の仕組みが異なるため0を中継して分解する
        doZoom(0, before).then(()=>{
          doZoom(after, 0).then(()=>{
            this.zoomBusy = false;
          });
        });
      }
    }
  },
  mounted(){
    this.renderer = new THREE.WebGLRenderer({
      antialias: false,
      canvas: this.$refs.canvas
    });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.width, this.height);

    /* //光 いらないかもしれない
    //ambientLight
    this.scene.add(new THREE.AmbientLight(0x454545));
    //DirectionalLight
    const directional = new THREE.DirectionalLight(0xFFFFFF, 1.0);
    directional.position.set(45, 35, 105);
    this.scene.add(directional);
    */
    
    this.camera.position.set(0, 0, 0);
    this.zoom=this.initialZoom;//初期ズーム値反映

    
    //オービットコントロール
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.dampingFactor = 0.5;
    this.controls.rotateSpeed = -0.5;
    this.controls.target = this.focus;
    this.controls.minDistance = 0;
    // this.controls.maxDistance = 400;
    this.controls.enableZoom = false;
    

    if(this.mainImagePath){
      this.setMaterial(this.mainImagePath);
    }

    //球体オブジェクト
    this.sphereMesh = (()=> {
      new THREE.SphereBufferGeometry(500, 60, 40);
      var geometry = new THREE.SphereBufferGeometry(500, 60, 40);
      geometry.scale(-1, 1, 1);
      var tex = new THREE.Texture();
      tex.mapFilter = THREE.LinearFilter;
      tex.minFilter = THREE.LinearFilter;
      var material = new THREE.MeshBasicMaterial({
        map: tex,
        transparent: true,
      });
      return new THREE.Mesh(geometry, material);
    })();
    this.scene.add(this.sphereMesh);

    this.tick();
  },
  methods: {
    ...mapActions([
      'featureMarkerVisibleChange',
      'displayFeature'
    ]),
    //毎フレーム実行されるイベントループ
    tick:function(){
      this.setFitSize();
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
      this.setFeatureMarkerPosition();
      requestAnimationFrame(this.tick);
    },
    //球体画像変更
    setMaterial(path){
      this.imgLoading = true;
      var img = new Image();
      img.onload = ()=>{
        this.sphereMesh.material.map = new THREE.Texture(img);
        this.sphereMesh.material.map.needsUpdate = true;
        this.imgLoading = false;
        this.firstImgLoaded = true;
      };
      img.src = path;
    },
    //ワールド座標=>スクリーン座標変換
    getWorldToScreen2D(_targetMesh) {
      const vector = new THREE.Vector3();
      // let widthHalf = 0.5 * this.renderer.context.canvas.width;
      // let heightHalf = 0.5 * this.renderer.context.canvas.height;
      let widthHalf = 0.5 * this.renderer.getContext().canvas.width;
      let heightHalf = 0.5 * this.renderer.getContext().canvas.height;

      widthHalf = widthHalf / window.devicePixelRatio;
      heightHalf = heightHalf / window.devicePixelRatio;
      _targetMesh.updateMatrixWorld();
      vector.setFromMatrixPosition(_targetMesh.matrixWorld);
      vector.project(this.camera);
      vector.x = (vector.x * widthHalf) + widthHalf;
      vector.y = -(vector.y * heightHalf) + heightHalf;
      const _dir0 = new THREE.Vector3().subVectors(this.focus, this.camera.position);
      const _dir1 = new THREE.Vector3().subVectors(_targetMesh.position, this.camera.position);
      const _d = _dir0.dot(_dir1);
      if (_d <= 0) {
        vector.x = -9999;
        vector.y = -9999;
      }
      return {
        x: vector.x,
        y: vector.y
      };
    },
    //訴求ポイントマーカー配置
    setFeatureMarker(data){
      //配置済みのマーカーを削除
      this.featureMarkersMeshArr.forEach((point)=>{
        this.scene.remove(point.mesh);
        point.mesh.geometry.dispose();
        point.mesh.material.dispose();
      });
      this.featureMarkersMeshArr = [];
      this.featureMarkerPosition = {};
      //新規マーカー作成
      let tmpMarker;
      for(var key in data){
        tmpMarker = {
          id: key,
          mesh: null,
          geometry: new THREE.SphereBufferGeometry( 5, 32, 32 ),
          material: new THREE.MeshBasicMaterial({
            side: THREE.FrontSide,
            // color: 0x0000ff,//test表示確認用の青色
          }),
        };
        tmpMarker.mesh = new THREE.Mesh(
          tmpMarker.geometry,
          tmpMarker.material
        )
        tmpMarker.mesh.visible = false;//非表示
        tmpMarker.mesh.position.x = data[key].positions[0].x;
        tmpMarker.mesh.position.y = data[key].positions[0].y;
        tmpMarker.mesh.position.z = data[key].positions[0].z;
        this.scene.add(tmpMarker.mesh);
        this.featureMarkersMeshArr.push(tmpMarker);
      }
    },
    //訴求ポイント二次元座標を設定
    setFeatureMarkerPosition(){
      this.featureMarkersMeshArr.forEach((point)=>{
        const pos = this.getWorldToScreen2D(point.mesh);
        Vue.set(this.featureMarkerPosition, point.id, {id:point.id,...this.featureMarkerPosition[point.id], ...pos});
      });
    },
    zoomChange: function(flg){
      if(this.zoom==null || this.zoomBusy){//初期値セット前とアニメーション中の変更を受け付けない
        return false;
      }
      if(flg === 1 && !this.zoomMaxFlg){//拡大
        this.zoom += 1;
      }else if(flg === -1 && !this.zoomMinFlg){//縮小
        this.zoom -= 1;
      }else if(flg === 0){//リセット
        this.zoom = this.initialZoom;
      }
    },
    //カメラのzoom値を操作するアニメーション 正の範囲（0〜2）の拡縮
    zoomInAnimationTypeP: function(goal){
      const camera = this.camera;
      const diff = goal-camera.zoom;
      const step = diff*0.05;
      return new Promise(function(resolve){
        function zoomLoop(){
          let next = camera.zoom+step;
          if((step>0 && next>=goal)||(step<0 && next<=goal)){
            next = goal;
          }
          camera.zoom = next;
          camera.updateProjectionMatrix();
          if(next === goal){
            resolve();
          }
          else{
            requestAnimationFrame(zoomLoop);
          }
        }
        zoomLoop();
      });
    },
    //カメラのtranslateZ値を操作するアニメーション 負の範囲（0〜-2）の拡縮
    zoomInAnimationTypeN: function(goal){
      const camera = this.camera;
      let savedZ = 0;
      const dirFlg = goal>0?1:-1;
      const step = goal*0.05;
      return new Promise(function(resolve){
        function zoomLoop(){
          camera.translateZ(-savedZ);
          let next = savedZ+=step;
          if((dirFlg>0 && next >= goal)||(dirFlg<0 && next <= goal)){
            next = goal;
          }
          savedZ=next;
          camera.translateZ(savedZ);
          camera.updateProjectionMatrix();
           if(savedZ === goal){
            resolve();
          }
          else{
            requestAnimationFrame(zoomLoop);
          }
        }
        zoomLoop();
      });
    },
    //WEBGLのリキッド化
    setFitSize: function(){
      const viewArea_w = this.$refs.viewerArea.clientWidth;
      const viewArea_h = this.$refs.viewerArea.clientHeight;

      if(viewArea_w === this.fitsizeSaved_w && viewArea_h === this.fitsizeSaved_h){
        //ビューエリアのサイズ変化なし 終了
        return;
      }else{
        //ビューエリアのサイズを保存
        this.fitsizeSaved_w = viewArea_w;
        this.fitsizeSaved_h = viewArea_h;
      }
      
      let newW,newH;

      if(viewArea_w/this.width >= viewArea_h/this.height){
        newW = viewArea_w;
        newH = this.height * viewArea_w / this.width;
      }else{
        newW = this.width * viewArea_h / this.height;
        newH = viewArea_h;
      }
      this.renderer.setSize(newW, newH);
    }
  }
};
</script>

<style lang="scss" scoped>
.viewerArea{
  position: relative;
  overflow: hidden;
  // width: 1360px;
  // height: 709px;
  width: 100%;
  flex-grow: 1;

}
.cavas-wrap{
  line-height: 0;
  position: absolute;
  overflow: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

